import { ITableColumn } from '../../../../../../../../components/UIWidgets/TableWrapper/models';

export const MARKETS_COLUMNS: ITableColumn[] = [
  {
    label: 'Date',
    dataKey: 'closeTimestamp',
    flexGrow: 1,
    width: 150,
    display: true,
    disableSort: false,
  },
  {
    label: 'Price',
    dataKey: 'price',
    flexGrow: 3,
    width: 250,
    display: true,
    disableSort: false,
  },
  {
    label: '',
    dataKey: 'priceAction',
    flexGrow: 0,
    width: 18,
    display: true,
    disableSort: true,
  },
];
